var url = ''
if (window.location.host === 'nilecity-qr.premiere-cinemas.com') {
  url = 'https://nilecity-api.premiere-cinemas.com'
} else {
  url = 'https://nilecity-api.premiere-cinemas.com'
}
export const URL_BASE = url



// WEBPACK FOOTER //
// ./src/helper/constants.js